import { _apiPost, _apiPut, _apiDelete } from "../../lib/apiClient";

export async function apiCreateAppointment(payload) { return _apiPost("/appointments", payload); }
export async function apiUpdateAppointment(id, payload) { return _apiPut(`/appointments/${id}`, payload); }
export async function apiSetAppointmentStatus(id, status) { return _apiPost(`/appointments/${id}/status`, { status }); }
export async function apiDeleteAppointment(id) { return _apiDelete(`/appointments/${id}`); }

// --- Routing / claim / assistant notes (admin-tasks UI) -------------
export async function apiRerouteAppointment(id, { assistantIds, notesVisibleToAssistant }) {
  return _apiPost(`/appointments/${id}/reroute`, { assistantIds, notesVisibleToAssistant });
}
export async function apiClaimAppointment(id) { return _apiPost(`/appointments/${id}/claim`, {}); }
export async function apiAddAssistantNote(id, text) { return _apiPost(`/appointments/${id}/assistant-note`, { text }); }
